import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Features } from '@app/core/user-permissions/user-permissions.model';
import { UserPermissionsService } from '@app/core/user-permissions/user-permissions.service';
import { combineLatest, Observable } from 'rxjs';
import { filter, map, take } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class HasSmartDevicesWritePermissionGuard  {
  constructor(
    private readonly permissionsService: UserPermissionsService,
    private router: Router
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return combineLatest([
      this.permissionsService.loaded.pipe(filter((loaded) => loaded)),
      this.permissionsService.hasAccessTo(Features.PERM_SMARTLOCKS_DASHBOARD_WRITE),
    ]).pipe(
      take(1),
      map(([permissionsLoaded, hasAccess]) => {
        if (!hasAccess) {
          // Redirect to denied page if user doesn't have access
          return this.router.createUrlTree(['/dashboard/denied']);
        }
        return true;
      })
    );
  }
}
